import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

class ApiService {
  constructor() {
    this.client = axios.create({
      baseURL: API_URL,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  // Health check
  async healthCheck() {
    try {
      const response = await this.client.get('/health');
      return response.data;
    } catch (error) {
      console.error('Health check failed:', error);
      return null;
    }
  }

  // Holidays
  async getAvailableCountries() {
    const response = await this.client.get('/api/holidays/countries');
    return response.data;
  }

  async getPublicHolidays(countryCode, year) {
    const response = await this.client.get(`/api/holidays/${countryCode}/${year}`);
    return response.data;
  }

  async getPublicHolidaysRange(countryCode, startYear, endYear) {
    const response = await this.client.get(
      `/api/holidays/${countryCode}/range/${startYear}/${endYear}`
    );
    return response.data;
  }

  // Users
  async createOrUpdateUser(name, email, countryCode) {
    const response = await this.client.post('/api/users', {
      name,
      email,
      countryCode
    });
    return response.data;
  }

  async getUser(email) {
    try {
      const response = await this.client.get(`/api/users/${email}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async updateUserCountry(email, countryCode) {
    const response = await this.client.patch(`/api/users/${email}/country`, {
      countryCode
    });
    return response.data;
  }

  // Attendance
  async getAttendanceRecords(userId, startDate, endDate) {
    const response = await this.client.get(`/api/attendance/${userId}`, {
      params: { startDate, endDate }
    });
    return response.data;
  }

  async bulkUpsertAttendance(userId, records) {
    const response = await this.client.post('/api/attendance/bulk', {
      userId,
      records
    });
    return response.data;
  }

  async updateAttendanceRecord(userId, date, status) {
    const response = await this.client.put(`/api/attendance/${userId}/${date}`, {
      status
    });
    return response.data;
  }

  async deleteAttendanceRecord(userId, date) {
    const response = await this.client.delete(`/api/attendance/${userId}/${date}`);
    return response.data;
  }

  async getSyncStats(userId) {
    const response = await this.client.get(`/api/attendance/${userId}/sync/stats`);
    return response.data;
  }
}

const apiServiceInstance = new ApiService();
export default apiServiceInstance;
